import { render, staticRenderFns } from "./LoginPrompt.vue?vue&type=template&id=057be556"
import script from "./LoginPrompt.vue?vue&type=script&lang=js"
export * from "./LoginPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports